<template>
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.2392 7.16579L13.7452 12.8018C14.0873 13.1516 14.0873 13.7193 13.7452 14.0692C13.4032 14.4193 12.8492 14.4193 12.5071 14.0692L7.00105 8.43317L1.49472 14.0692C1.15264 14.4193 0.598647 14.4193 0.256563 14.0692C-0.085521 13.7193 -0.085521 13.1516 0.256563 12.8018L5.76289 7.16579L0.256563 1.52979C-0.085521 1.17993 -0.085521 0.612263 0.256563 0.262403C0.427605 0.0876226 0.651769 8.2016e-05 0.875642 8.2016e-05C1.09951 8.2016e-05 1.32368 0.0876226 1.49472 0.262702L7.00105 5.8987L12.5071 0.262702C12.6781 0.0876226 12.9023 8.2016e-05 13.1262 8.2016e-05C13.35 8.2016e-05 13.5742 0.0876226 13.7452 0.262702C14.0873 0.612561 14.0873 1.18023 13.7452 1.53008L8.2392 7.16579Z"
      fill="#404A57"
    />
  </svg>
</template>

<script>
export default {
  name: "IconCancel",
};
</script>

<style></style>
